// import React, { useState, useRef, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faUser, faLock, faEye, faEyeSlash, faLock as faLockIcon } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import HOST_URL from "../utils/Url";
// import useLocalStorage from "use-local-storage";
// import { Button, CircularProgress, Grid, Box, Container, useMediaQuery, useTheme } from "@mui/material";
// import { useFormik } from "formik";
// import { toast, ToastContainer } from "react-toastify";
// import * as Yup from 'yup';
// import advPics from '../assets/images/headDoc.png';
// import logo from '../assets/images/recyclebinLogo.png';
// import { keyframes } from "@emotion/react";
// import { secureSetItem, encryptData } from "../utils/encryption";
// import ReCAPTCHA from "react-google-recaptcha";

// function LoginPage() {
//   const [remainingAttempts, setRemainingAttempts] = useState<number | null>(null);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [unlockTime, setUnlockTime] = useState<Date | null>(null);
//   const [remainingTime, setRemainingTime] = useState<{ minutes: number; seconds: number } | null>(null);
//   const [isAccountLocked, setIsAccountLocked] = useState(false);
//   const timer = useRef<ReturnType<typeof setTimeout>>();
//   const recaptchaRef = useRef<ReCAPTCHA>(null);
//   const navigate = useNavigate();
//   const [tokenKey, setTokenKey] = useLocalStorage("name", "");
//   const [backgroundPosition, setBackgroundPosition] = useState("0% 0%");
//   const [imageHover, setImageHover] = useState(false);

//   // Animated background effect
//   useEffect(() => {
//     if (!isMobile) {
//       const interval = setInterval(() => {
//         setBackgroundPosition(prev => {
//           const x = Math.floor(Math.random() * 100);
//           const y = Math.floor(Math.random() * 100);
//           return `${x}% ${y}%`;
//         });
//       }, 10000);
//       return () => clearInterval(interval);
//     }
//   }, [isMobile]);

//   // Countdown timer effect
//   useEffect(() => {
//     if (unlockTime) {
//       const interval = setInterval(() => {
//         const now = new Date().getTime();
//         const diff = unlockTime.getTime() - now;
//         if (diff <= 0) {
//           clearInterval(interval);
//           setRemainingAttempts(null);
//           setUnlockTime(null);
//           setRemainingTime(null);
//           setIsAccountLocked(false);
//         } else {
//           const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//           const seconds = Math.floor((diff % (1000 * 60)) / 1000);
//           setRemainingTime({ minutes, seconds });
//         }
//       }, 1000);
//       return () => clearInterval(interval);
//     }
//   }, [unlockTime]);

//   const parseUnlockTime = (lockTimeStr: string): Date => {
//     const timeMatch = lockTimeStr.match(/(\d{1,2}):(\d{2}) ([AP]M)/i);
//     if (timeMatch) {
//       const now = new Date();
//       let hours = parseInt(timeMatch[1]);
//       const minutes = parseInt(timeMatch[2]);
//       const ampm = timeMatch[3].toUpperCase();
//       if (ampm === 'PM' && hours !== 12) hours += 12;
//       if (ampm === 'AM' && hours === 12) hours = 0;
//       const unlock = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0);
//       if (unlock < now) unlock.setDate(unlock.getDate() + 1);
//       return unlock;
//     } else {
//       const durationMatch = lockTimeStr.match(/(\d+)\s*minutes?/i);
//       if (durationMatch) {
//         const min = parseInt(durationMatch[1]);
//         return new Date(new Date().getTime() + min * 60000);
//       }
//     }
//     // Default to 15 minutes
//     return new Date(new Date().getTime() + 15 * 60000);
//   };

//   const validationSchema = Yup.object({
//     useR_ID: Yup.string()
//       .required("Username is required"),
//     password: Yup.string()
//       .required("Password is required"),
//       gRecaptchaResponse: Yup.string()
//   .required("Please complete the CAPTCHA"),
//   });

//   const formik = useFormik({
//     initialValues: {
//       useR_ID: "",
//       password: "",
//       collageID: "1",
//       packageID: "1",
//       gRecaptchaResponse: "",
//     },
//     validationSchema: validationSchema,
//     onSubmit: () => {}, // Empty function since we handle submission manually
//   });

//   const handleCaptchaChange = (token: string | null) => {
//     formik.setFieldValue("gRecaptchaResponse", token || "");
//   };

//   const handleCaptchaExpired = () => {
//     formik.setFieldValue("gRecaptchaResponse", "");
//   };

//   const resetCaptcha = () => {
//     recaptchaRef.current?.reset();
//     formik.setFieldValue("gRecaptchaResponse", "");
//   };

//   const handleButtonClick = async () => {
//     if (!loading) {
//       setSuccess(false);
//       setLoading(true);
//       let hasError = false;
//       try {
//         await formik.validateForm();
//         if (Object.keys(formik.errors).length === 0) {
//           // Encrypt the sensitive data before sending
//           const encryptedPayload = {
//             useR_ID: encryptData(formik.values.useR_ID),
//             password: encryptData(formik.values.password),
//             collageID: formik.values.collageID,
//             packageID: formik.values.packageID,
//             gRecaptchaResponse: formik.values.gRecaptchaResponse
//           };

//           // Send the encrypted payload directly
//           const response = await axios.post(HOST_URL.HOST_URL + `USER/USERLOGIN`, encryptedPayload);

//           // Check if response is successful
//           if (response.data.isSuccess) {
//             if (response.data.data[0]["userPermission"] == null) {
//               toast.error("User Permission is null");
//               hasError = true;
//             } else {
//               // Use secure storage instead of localStorage
//               secureSetItem("userdata", response.data.data);
//               secureSetItem("useR_ID", response.data.data[0]["userdetail"][0]["useR_ID"]);
//               secureSetItem("devID", response.data.data[0]["userdetail"][0]["departmentId"]);
//               secureSetItem("devName", response.data.data[0]["userdetail"][0]["department_Name"]);

//               // For sessionStorage
//               sessionStorage.setItem("token", response.data.data[0]["token"]);

//               navigate(`/home`);
//               toast.success(response.data.mesg || "Login successful");
//               formik.resetForm();
//               // Reset attempts on successful login
//               setRemainingAttempts(null);
//               setUnlockTime(null);
//               setIsAccountLocked(false);
//             }
//             timer.current = setTimeout(() => {
//               setSuccess(true);
//               setLoading(false);
//             }, 1000);
//           } else {
//             hasError = true;
//             // Handle failed login attempts
//             const errorMessage = response.data.mesg || "Login failed";

//             // For "Invalid credentials" message, we need to handle it specially
//             if (errorMessage === "Invalid credentials") {
//               // Decrement remaining attempts
//               setRemainingAttempts(prev => {
//                 const newAttempts = prev !== null ? Math.max(0, prev - 1) : 4;
//                 // Show message with remaining attempts
//                 toast.error(`Invalid credentials. You have ${newAttempts} attempt${newAttempts !== 1 ? 's' : ''} remaining`);
//                 return newAttempts;
//               });
//             }
//             // Check if the error message contains attempt information
//             else if (errorMessage.includes("attempt") || errorMessage.includes("attempts")) {
//               // Extract the number of remaining attempts from the message
//               const attemptsMatch = errorMessage.match(/(\d+)\s+attempt/);
//               if (attemptsMatch && attemptsMatch[1]) {
//                 setRemainingAttempts(parseInt(attemptsMatch[1]));
//               } else {
//                 // If we can't parse the number, decrement from previous value
//                 setRemainingAttempts(prev => prev !== null ? Math.max(0, prev - 1) : 4);
//               }

//               toast.error(errorMessage);
//             } 
//             // Check if account is locked
//             else if (errorMessage.includes("locked") || errorMessage.includes("Try again after")) {
//               // Extract lock time from message if available
//               const timeMatch = errorMessage.match(/Try again after\s+(.*)$/);
//               const lockTimeStr = timeMatch ? timeMatch[1] : "15 minutes";
//               const parsedUnlockTime = parseUnlockTime(lockTimeStr);
//               setUnlockTime(parsedUnlockTime);
//               setIsAccountLocked(true); // Set account locked state
//               toast.error(errorMessage);
//               setRemainingAttempts(0); // No attempts left when locked
//             } 
//             // Generic error
//             else {
//               toast.error(errorMessage);
//             }

//             setLoading(false);
//           }
//         } else {
//           hasError = true;
//           setLoading(false);
//         }
//       } catch (error: any) {
//         hasError = true;
//         // Handle axios errors
//         if (error.response && error.response.data) {
//           const errorData = error.response.data;
//           const errorMessage = errorData.mesg || "Login Failed";

//           // For "Invalid credentials" message
//           if (errorMessage === "Invalid credentials") {
//             setRemainingAttempts(prev => {
//               const newAttempts = prev !== null ? Math.max(0, prev - 1) : 4;
//               toast.error(`Invalid credentials. You have ${newAttempts} attempt${newAttempts !== 1 ? 's' : ''} remaining`);
//               return newAttempts;
//             });
//           }
//           // Check if the error message contains attempt information
//           else if (errorMessage.includes("attempt") || errorMessage.includes("attempts")) {
//             // Extract the number of remaining attempts from the message
//             const attemptsMatch = errorMessage.match(/(\d+)\s+attempt/);
//             if (attemptsMatch && attemptsMatch[1]) {
//               setRemainingAttempts(parseInt(attemptsMatch[1]));
//             }

//             toast.error(errorMessage);
//           } 
//           // Check if account is locked
//           else if (errorMessage.includes("locked") || errorMessage.includes("Try again after")) {
//             // Extract lock time from message if available
//             const timeMatch = errorMessage.match(/Try again after\s+(.*)$/);
//             const lockTimeStr = timeMatch ? timeMatch[1] : "15 minutes";
//             const parsedUnlockTime = parseUnlockTime(lockTimeStr);
//             setUnlockTime(parsedUnlockTime);
//             setIsAccountLocked(true); // Set account locked state
//             toast.error(errorMessage);
//             setRemainingAttempts(0); // No attempts left when locked
//           } 
//           // Generic error
//           else {
//             toast.error(errorMessage);
//           }
//         } else {
//           toast.error("Login Failed");
//         }
//         setLoading(false);
//       } finally {
//         if (hasError) {
//           resetCaptcha();
//         }
//       }
//     }
//   };

//   const AttemptsMessage = () => {
//     if (remainingAttempts === null || remainingAttempts === 0) return null;

//     return (
//       <Box sx={{
//         width: '100%',
//         textAlign: 'center',
//         marginTop: '0.5rem',
//         padding: '0.3rem',
//         borderRadius: '4px',
//         backgroundColor: remainingAttempts > 2 ? '#e8f5e8' : 
//                          remainingAttempts > 1 ? '#fff3cd' : '#f8d7da',
//         color: remainingAttempts > 2 ? '#2e7d32' : 
//                remainingAttempts > 1 ? '#856404' : '#721c24',
//         fontSize: '0.8rem',
//         fontWeight: '500'
//       }}>
//         {`You have ${remainingAttempts} attempt${remainingAttempts !== 1 ? 's' : ''} remaining`}
//       </Box>
//     );
//   };

//   const LockedScreen = () => (
//     <Box sx={{ 
//       textAlign: 'center', 
//       padding: '1.5rem',
//       backgroundColor: '#fff9f9',
//       borderRadius: '8px',
//       border: '1px solid #ffebee'
//     }}>
//       <FontAwesomeIcon icon={faLockIcon} size="3x" color="#d32f2f" />
//       <h3 style={{ marginTop: '1rem', color: '#d32f2f' }}>Account Locked</h3>
//       <p style={{ color: '#555' }}>Your account is temporarily locked due to multiple failed login attempts.</p>
//       {remainingTime && (
//         <Box sx={{
//           marginTop: '1rem',
//           padding: '0.8rem',
//           backgroundColor: '#ffebee',
//           borderRadius: '6px',
//           display: 'inline-block'
//         }}>
//           <p style={{
//             color: '#d32f2f',
//             fontSize: '1.4rem',
//             fontWeight: 'bold',
//             margin: 0
//           }}>
//             Please try again in {remainingTime.minutes}:{remainingTime.seconds.toString().padStart(2, '0')} minutes
//           </p>
//         </Box>
//       )}
//     </Box>
//   );

//   // Animation keyframes
//   const gradientAnimation = keyframes`
//     0% { background-position: 0% 50%; }
//     50% { background-position: 100% 50%; }
//     100% { background-position: 0% 50%; }
//   `;

//   const fadeIn = keyframes`
//     from { opacity: 0; transform: translateY(20px); }
//     to { opacity: 1; transform: translateY(0); }
//   `;

//   const floatAnimation = keyframes`
//     0% { transform: translateY(0px); }
//     25% { transform: translateY(-15px); }
//     50% { transform: translateY(0px); }
//     75% { transform: translateY(10px); }
//     100% { transform: translateY(0px); }
//   `;

//   const pulseAnimation = keyframes`
//     0% { transform: scale(1); }
//     50% { transform: scale(1.05); }
//     100% { transform: scale(1); }
//   `;

//   // Styles
//   const styles = {
//     loginContainer: {
//       width: '100%',
//       minHeight: '100vh',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       padding: 0,
//       margin: 0,
//       overflow: 'hidden',
//       position: 'relative',
//       backgroundColor: isMobile ? '#e3f2fd' : 'transparent',
//       ...(!isMobile && {
//         background: 'linear-gradient(270deg, #f5f7fa, #c3cfe2, #a1c4fd, #c2e9fb)',
//         backgroundSize: '400% 400%',
//         animation: `${gradientAnimation} 15s ease infinite`,
//       }),
//     },
//     formContainer: {
//       width: '100%',
//       maxWidth: isMobile ? '350px' : '400px',
//       padding: isMobile ? '1rem' : '1.5rem',
//       boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
//       borderRadius: '12px',
//       backgroundColor: 'rgba(255, 255, 255, 0.95)',
//       backdropFilter: 'blur(5px)',
//       animation: `${fadeIn} 0.6s ease-out`,
//       transform: 'translateZ(0)',
//       transition: 'all 0.3s ease',
//       '&:hover': !isMobile ? {
//         boxShadow: '0 15px 35px rgba(0,0,0,0.15)',
//         transform: 'translateY(-5px)'
//       } : {},
//     },
//     logo: {
//       height: isMobile ? '10vh' : '12vh',
//       width: isMobile ? '10vh' : '12vh',
//       margin: '5px',
//       objectFit: 'contain',
//       filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
//       animation: `${pulseAnimation} 3s ease-in-out infinite`
//     },
//     title: {
//       fontSize: isMobile ? '1.1rem' : '1.4rem',
//       textAlign: 'center',
//       margin: '0.3rem 0',
//       color: '#444',
//       fontWeight: '600',
//       textShadow: '0 1px 2px rgba(0,0,0,0.1)'
//     },
//     subtitle: {
//       fontSize: isMobile ? '0.7rem' : '0.9rem',
//       textAlign: 'center',
//       fontStyle: 'italic',
//       color: '#555',
//       marginBottom: '0.5rem',
//       opacity: 0.8,
//       animation: `${fadeIn} 1s ease-out`
//     },
//     inputContainer: {
//       display: 'flex',
//       alignItems: 'center',
//       border: '1px solid rgba(0,0,0,0.1)',
//       borderRadius: '8px',
//       padding: '0.3rem',
//       marginBottom: '0.3rem',
//       width: '100%',
//       backgroundColor: 'rgba(255,255,255,0.8)',
//       transition: 'all 0.3s ease',
//       '&:focus-within': {
//         borderColor: '#4a90e2',
//         boxShadow: '0 0 0 2px rgba(74,144,226,0.2)'
//       }
//     },
//     captchaContainer: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       border: '1px solid rgba(0,0,0,0.1)',
//       borderRadius: '8px',
//       padding: '0.3rem',
//       marginBottom: '0.3rem',
//       width: '100%',
//       backgroundColor: 'rgba(255,255,255,0.8)',
//       transition: 'all 0.3s ease',
//       '&:focus-within': {
//         borderColor: '#4a90e2',
//         boxShadow: '0 0 0 2px rgba(74,144,226,0.2)'
//       }
//     },
//     input: {
//       flex: 1,
//       border: 'none',
//       outline: 'none',
//       fontSize: isMobile ? '0.8rem' : '0.9rem',
//       padding: '0.3rem',
//       backgroundColor: 'transparent',
//       '&::placeholder': {
//         color: '#aaa'
//       }
//     },
//     errorText: {
//       color: '#ff4444',
//       fontSize: '0.7rem',
//       marginTop: '-0.3rem',
//       marginBottom: '0.3rem',
//       textAlign: 'left',
//       width: '100%',
//       fontWeight: '500'
//     },
//     button: {
//       width: isMobile ? '100%' : '60%',
//       margin: '0.3rem 0',
//       padding: '0.6rem',
//       borderRadius: '8px',
//       fontWeight: '600',
//       letterSpacing: '0.5px',
//       transition: 'all 0.3s ease',
//       '&:hover': {
//         transform: 'translateY(-2px)',
//         boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
//       }
//     },
//     imageSection: {
//       display: isMobile ? 'none' : 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       height: '100vh',
//       position: 'relative',
//       overflow: 'hidden',
//       '&::before': {
//         content: '""',
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
//         zIndex: 1
//       }
//     },
//     welcomeText: {
//       fontSize: '1.6rem',
//       color: '#333',
//       marginBottom: '0.8rem',
//       fontWeight: '700',
//       textShadow: '0 2px 4px rgba(0,0,0,0.1)',
//       animation: `${fadeIn} 0.8s ease-out`
//     },
//     description: {
//       fontSize: '1rem',
//       color: '#555',
//       lineHeight: '1.5',
//       maxWidth: '450px',
//       opacity: 0.9,
//       animation: `${fadeIn} 1s ease-out`
//     },
//     backgroundAnimation: {
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       background: `radial-gradient(circle at ${backgroundPosition}, rgba(161,196,253,0.3) 0%, rgba(194,233,251,0.1) 50%, rgba(255,255,255,0) 100%)`,
//       transition: 'background-position 8s ease-out',
//       zIndex: 0
//     },
//     floatingImage: {
//       maxWidth: '100%',
//       height: 'auto',
//       maxHeight: '50vh',
//       filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.1))',
//       transform: imageHover ? 'perspective(1000px) rotateY(0deg) scale(1.05)' : 'perspective(1000px) rotateY(-5deg)',
//       transition: 'transform 0.5s ease, filter 0.3s ease',
//       animation: `${floatAnimation} 4s ease-in-out infinite`,
//       cursor: 'pointer'
//     }
//   };

//   return (
//     <Container maxWidth={false} sx={styles.loginContainer}>
//       <ToastContainer/>
//       {!isMobile && <Box sx={styles.backgroundAnimation} />}

//       <Grid container sx={{
//         flexGrow: 1,
//         alignItems: 'center',
//         justifyContent: 'center',
//         position: 'relative',
//         zIndex: 1,
//         height: isMobile ? 'auto' : '100vh',
//         overflow: isMobile ? 'hidden' : 'visible'
//       }}>
//         {/* Image Section - Hidden on mobile */}
//         {!isMobile && (
//           <Grid item xs={12} md={6} sx={styles.imageSection}>
//             <Box sx={{
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               justifyContent: 'center',
//               padding: '1rem',
//               textAlign: 'center',
//               position: 'relative',
//               zIndex: 2
//             }}>
//               <img
//                 alt="Document Management"
//                 src={advPics}
//                 style={styles.floatingImage as React.CSSProperties}
//                 onMouseEnter={() => setImageHover(true)}
//                 onMouseLeave={() => setImageHover(false)}
//                 onClick={() => setImageHover(!imageHover)}
//               />
//               <Box sx={{ marginTop: '1rem' }}>
//                 <h3 style={styles.welcomeText as React.CSSProperties}>Welcome to DDMSS</h3>
//                 <p style={styles.description as React.CSSProperties}>
//                   Streamline your document workflow with our comprehensive management system. 
//                   Organize, track, and access your documents with ease and efficiency.
//                 </p>
//               </Box>
//             </Box>
//           </Grid>
//         )}

//         {/* Form Section - Always centered */}
//         <Grid item xs={12} md={isMobile ? 12 : 6} sx={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           padding: isMobile ? '0.5rem' : '1rem',
//           height: isMobile ? 'auto' : 'auto',
//           overflowY: 'auto'
//         }}>
//           <Box sx={styles.formContainer}>
//             <Box sx={{
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               marginBottom: '1rem',
//             }}>
//               <img
//                 alt="Logo"
//                 src={logo}
//                 style={styles.logo as React.CSSProperties}
//               />
//               <h3 style={styles.title as React.CSSProperties}>Digital Document Management System Software</h3>
//               <i style={styles.subtitle as React.CSSProperties}>
//                 "Efficiency Unleashed: Your Documents, Organized!"
//               </i>
//             </Box>

//             {/* Show locked screen if account is locked */}
//             {isAccountLocked ? (
//               <LockedScreen />
//             ) : (
//               <>
//                 <form onSubmit={(e) => {
//                   e.preventDefault();
//                   handleButtonClick();
//                 }} 
//                 style={{
//                   width: '100%',
//                   display: 'flex',
//                   flexDirection: 'column',
//                   alignItems: 'center',
//                 }}>
//                   <Box sx={{ marginBottom: '1rem', width: '100%' }}>
//                     <Box sx={styles.inputContainer}>
//                       <FontAwesomeIcon
//                         icon={faUser}
//                         style={{ color: '#4a90e2', margin: '0 5px' }}
//                       />
//                       <input
//                         type="text"
//                         name="useR_ID"
//                         id="useR_ID"
//                         value={formik.values.useR_ID}
//                         placeholder="Username"
//                         onChange={formik.handleChange}
//                         onBlur={formik.handleBlur}
//                         style={styles.input}
//                       />
//                     </Box>
//                     {formik.touched.useR_ID && formik.errors.useR_ID && (
//                       <div style={styles.errorText as React.CSSProperties}>{formik.errors.useR_ID}</div>
//                     )}

//                     <Box sx={styles.inputContainer}>
//                       <FontAwesomeIcon
//                         icon={faLock}
//                         style={{ color: '#4a90e2', margin: '0 5px' }}
//                       />
//                       <input
//                         type={showPassword ? "text" : "password"}
//                         name="password"
//                         id="password"
//                         value={formik.values.password}
//                         placeholder="Password"
//                         onChange={formik.handleChange}
//                         onBlur={formik.handleBlur}
//                         style={styles.input}
//                       />
//                       <FontAwesomeIcon
//                         icon={showPassword ? faEyeSlash : faEye}
//                         style={{ color: '#4a90e2', margin: '0 5px', cursor: 'pointer' }}
//                         onClick={() => setShowPassword(!showPassword)}
//                       />
//                     </Box>
//                     {formik.touched.password && formik.errors.password && (
//                       <div style={styles.errorText as React.CSSProperties}>{formik.errors.password}</div>
//                     )}

//                     {/* CAPTCHA Component */}
//                     <Box sx={styles.captchaContainer}>
//                       <ReCAPTCHA
//                         ref={recaptchaRef}
//                         sitekey="6LcBasQrAAAAAFors9vxneugK4N82CUfqhm763YB"
//                         onChange={handleCaptchaChange}
//                         onExpired={handleCaptchaExpired}
//                       />
//                     </Box>
//                     {formik.touched.gRecaptchaResponse && formik.errors.gRecaptchaResponse && (
//                       <div style={styles.errorText as React.CSSProperties}>{formik.errors.gRecaptchaResponse}</div>
//                     )}
//                   </Box>

//                   <Box sx={{
//                     display: 'flex',
//                     justifyContent: 'center',
//                     width: '100%',
//                   }}>
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       disabled={loading}
//                       sx={styles.button}
//                       onClick={handleButtonClick}
//                       type="submit"
//                     >
//                       {loading ? (
//                         <CircularProgress size={24} style={{ color: "white" }} />
//                       ) : (
//                         "Sign In"
//                       )}
//                     </Button>
//                   </Box>
//                 </form>
//                 <AttemptsMessage />
//               </>
//             )}
//           </Box>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// }

// export default LoginPage;


// import React, { useState, useRef, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faUser, faLock, faEye, faEyeSlash, faLock as faLockIcon } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import HOST_URL from "../utils/Url";
// import useLocalStorage from "use-local-storage";
// import { Button, CircularProgress, Grid, Box, Container, useMediaQuery, useTheme } from "@mui/material";
// import { useFormik } from "formik";
// import { toast, ToastContainer } from "react-toastify";
// import * as Yup from 'yup';
// import advPics from '../assets/images/headDoc.png';
// import logo from '../assets/images/recyclebinLogo.png';
// import { keyframes } from "@emotion/react";
// import { secureSetItem, encryptData } from "../utils/encryption";
// import ReCAPTCHA from "react-google-recaptcha";
// import SplashScreen from "./SplashScreen"; // Import the splash screen
// function LoginPage() {
//   const [remainingAttempts, setRemainingAttempts] = useState<number | null>(null);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
//   const isLaptop = useMediaQuery(theme.breakpoints.up('md'));
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [unlockTime, setUnlockTime] = useState<Date | null>(null);
//   const [remainingTime, setRemainingTime] = useState<{ minutes: number; seconds: number } | null>(null);
//   const [isAccountLocked, setIsAccountLocked] = useState(false);
//   const timer = useRef<ReturnType<typeof setTimeout>>();
//   const recaptchaRef = useRef<ReCAPTCHA>(null);
//   const navigate = useNavigate();
//   const [tokenKey, setTokenKey] = useLocalStorage("name", "");
//   const [backgroundPosition, setBackgroundPosition] = useState("0% 0%");
//   const [imageHover, setImageHover] = useState(false);
//   const [showSplash, setShowSplash] = useState(false); // New state for splash screen

//   // Animated background effect
//   useEffect(() => {
//     if (!isMobile && !isTablet) {
//       const interval = setInterval(() => {
//         setBackgroundPosition(prev => {
//           const x = Math.floor(Math.random() * 100);
//           const y = Math.floor(Math.random() * 100);
//           return `${x}% ${y}%`;
//         });
//       }, 10000);
//       return () => clearInterval(interval);
//     }
//   }, [isMobile, isTablet]);

//   // Countdown timer effect
//   useEffect(() => {
//     if (unlockTime) {
//       const interval = setInterval(() => {
//         const now = new Date().getTime();
//         const diff = unlockTime.getTime() - now;
//         if (diff <= 0) {
//           clearInterval(interval);
//           setRemainingAttempts(null);
//           setUnlockTime(null);
//           setRemainingTime(null);
//           setIsAccountLocked(false);
//         } else {
//           const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//           const seconds = Math.floor((diff % (1000 * 60)) / 1000);
//           setRemainingTime({ minutes, seconds });
//         }
//       }, 1000);
//       return () => clearInterval(interval);
//     }
//   }, [unlockTime]);

//   const parseUnlockTime = (lockTimeStrStr: string): Date => {
//     const timeMatch = lockTimeStrStr.match(/(\d{1,2}):(\d{2}) ([AP]M)/i);
//     if (timeMatch) {
//       const now = new Date();
//       let hours = parseInt(timeMatch[1]);
//       const minutes = parseInt(timeMatch[2]);
//       const ampm = timeMatch[3].toUpperCase();
//       if (ampm === 'PM' && hours !== 12) hours += 12;
//       if (ampm === 'AM' && hours === 12) hours = 0;
//       const unlock = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0);
//       if (unlock < now) unlock.setDate(unlock.getDate() + 1);
//       return unlock;
//     } else {
//       const durationMatch = lockTimeStrStr.match(/(\d+)\s*minutes?/i);
//       if (durationMatch) {
//         const min = parseInt(durationMatch[1]);
//         return new Date(new Date().getTime() + min * 60000);
//       }
//     }
//     // Default to 15 minutes
//     return new Date(new Date().getTime() + 15 * 60000);
//   };

//   const validationSchema = Yup.object({
//     useR_ID: Yup.string()
//       .required("Username is required"),
//     password: Yup.string()
//       .required("Password is required"),
//     // gRecaptchaResponse: Yup.string()
//     //   .required("Please complete the CAPTCHA"),
//   });

//   const formik = useFormik({
//     initialValues: {
//       useR_ID: "",
//       password: "",
//       collageID: "1",
//       packageID: "1",
//       gRecaptchaResponse: "",
//     },
//     validationSchema: validationSchema,
//     onSubmit: () => { }, // Empty function since we handle submission manually
//   });

//   const handleCaptchaChange = (token: string | null) => {
//     formik.setFieldValue("gRecaptchaResponse", token || "");
//   };

//   const handleCaptchaExpired = () => {
//     formik.setFieldValue("gRecaptchaResponse", "");
//   };

//   const resetCaptcha = () => {
//     recaptchaRef.current?.reset();
//     formik.setFieldValue("gRecaptchaResponse", "");
//   };

//   const handleButtonClick = async () => {
//     if (!loading) {
//       setSuccess(false);
//       setLoading(true);
//       let hasError = false;
//       try {
//         await formik.validateForm();
//         if (Object.keys(formik.errors).length === 0) {
//           // Encrypt the sensitive data before sending
//           const encryptedPayload = {
//             useR_ID: encryptData(formik.values.useR_ID),
//             password: encryptData(formik.values.password),
//             collageID: formik.values.collageID,
//             packageID: formik.values.packageID,
//             gRecaptchaResponse: formik.values.gRecaptchaResponse
//           };

//           // Send the encrypted payload directly
//           const response = await axios.post(HOST_URL.HOST_URL + `USER/USERLOGIN`, encryptedPayload);

//           if (response.data.isSuccess) {
//             if (response.data.data[0]["userPermission"] == null) {
//               toast.error("User Permission is null");
//               hasError = true;
//             } else {
//               // Use secure storage instead of localStorage
//               secureSetItem("userdata", response.data.data);
//               secureSetItem("useR_ID", response.data.data[0]["userdetail"][0]["useR_ID"]);
//               secureSetItem("devID", response.data.data[0]["userdetail"][0]["departmentId"]);
//               secureSetItem("devName", response.data.data[0]["userdetail"][0]["department_Name"]);
//               secureSetItem("subDeptID", response.data.data[0]["userdetail"][0]["subDeptID"]);

//               // For sessionStorage
//               sessionStorage.setItem("token", response.data.data[0]["token"]);

//               // Show splash screen before navigation
//               setShowSplash(true);

//               // Delay navigation to show splash screen
//               setTimeout(() => {
//                 navigate(`/home`);
//                 toast.success(response.data.mesg || "Login successful");
//                 formik.resetForm();
//                 // Reset attempts on successful login
//                 setRemainingAttempts(null);
//                 setUnlockTime(null);
//                 setIsAccountLocked(false);
//                 setShowSplash(false); // Hide splash screen after navigation
//               }, 3000); // 3 seconds splash screen

//               timer.current = setTimeout(() => {
//                 setSuccess(true);
//                 setLoading(false);
//               }, 1000);
//             }

//           } else {
//             hasError = true;
//             // Handle failed login attempts
//             const errorMessage = response.data.mesg || "Login failed";

//             // For "Invalid credentials" message, we need to handle it specially
//             if (errorMessage === "Invalid credentials") {
//               // Decrement remaining attempts
//               setRemainingAttempts(prev => {
//                 const newAttempts = prev !== null ? Math.max(0, prev - 1) : 4;
//                 // Show message with remaining attempts
//                 toast.error(`Invalid credentials. You have ${newAttempts} attempt${newAttempts !== 1 ? 's' : ''} remaining`);
//                 return newAttempts;
//               });
//             }
//             // Check if the error message contains attempt information
//             else if (errorMessage.includes("attempt") || errorMessage.includes("attempts")) {
//               // Extract the number of remaining attempts from the message
//               const attemptsMatch = errorMessage.match(/(\d+)\s+attempt/);
//               if (attemptsMatch && attemptsMatch[1]) {
//                 setRemainingAttempts(parseInt(attemptsMatch[1]));
//               } else {
//                 // If we can't parse the number, decrement from previous value
//                 setRemainingAttempts(prev => prev !== null ? Math.max(0, prev - 1) : 4);
//               }

//               toast.error(errorMessage);
//             }
//             // Check if account is locked
//             else if (errorMessage.includes("locked") || errorMessage.includes("Try again after")) {
//               // Extract lock time from message if available
//               const timeMatch = errorMessage.match(/Try again after\s+(.*)$/);
//               const lockTimeStr = timeMatch ? timeMatch[1] : "15 minutes";
//               const parsedUnlockTime = parseUnlockTime(lockTimeStr);
//               setUnlockTime(parsedUnlockTime);
//               setIsAccountLocked(true); // Set account locked state
//               toast.error(errorMessage);
//               setRemainingAttempts(0); // No attempts left when locked
//             }
//             // Generic error
//             else {
//               toast.error(errorMessage);
//             }

//             setLoading(false);
//           }
//         } else {
//           hasError = true;
//           setLoading(false);
//         }
//       } catch (error: any) {
//         hasError = true;
//         // Handle axios errors
//         if (error.response && error.response.data) {
//           const errorData = error.response.data;
//           const errorMessage = errorData.mesg || "Login Failed";

//           // For "Invalid credentials" message
//           if (errorMessage === "Invalid credentials") {
//             setRemainingAttempts(prev => {
//               const newAttempts = prev !== null ? Math.max(0, prev - 1) : 4;
//               toast.error(`Invalid credentials. You have ${newAttempts} attempt${newAttempts !== 1 ? 's' : ''} remaining`);
//               return newAttempts;
//             });
//           }
//           // Check if the error message contains attempt information
//           else if (errorMessage.includes("attempt") || errorMessage.includes("attempts")) {
//             // Extract the number of remaining attempts from the message
//             const attemptsMatch = errorMessage.match(/(\d+)\s+attempt/);
//             if (attemptsMatch && attemptsMatch[1]) {
//               setRemainingAttempts(parseInt(attemptsMatch[1]));
//             }

//             toast.error(errorMessage);
//           }
//           // Check if account is locked
//           else if (errorMessage.includes("locked") || errorMessage.includes("Try again after")) {
//             // Extract lock time from message if available
//             const timeMatch = errorMessage.match(/Try again after\s+(.*)$/);
//             const lockTimeStr = timeMatch ? timeMatch[1] : "15 minutes";
//             const parsedUnlockTime = parseUnlockTime(lockTimeStr);
//             setUnlockTime(parsedUnlockTime);
//             setIsAccountLocked(true); // Set account locked state
//             toast.error(errorMessage);
//             setRemainingAttempts(0); // No attempts left when locked
//           }
//           // Generic error
//           else {
//             toast.error(errorMessage);
//           }
//         } else {
//           toast.error("Login Failed");
//         }
//         setLoading(false);
//       } finally {
//         if (hasError) {
//           resetCaptcha();
//         }
//       }
//     }
//   };

//   const AttemptsMessage = () => {
//     if (remainingAttempts === null || remainingAttempts === 0) return null;

//     return (
//       <Box sx={{
//         width: '100%',
//         textAlign: 'center',
//         marginTop: '0.5rem',
//         padding: '0.3rem',
//         borderRadius: '4px',
//         backgroundColor: remainingAttempts > 2 ? '#e8f5e8' :
//           remainingAttempts > 1 ? '#fff3cd' : '#f8d7da',
//         color: remainingAttempts > 2 ? '#2e7d32' :
//           remainingAttempts > 1 ? '#856404' : '#721c24',
//         fontSize: isMobile ? '0.7rem' : '0.8rem',
//         fontWeight: '500'
//       }}>
//         {`You have ${remainingAttempts} attempt${remainingAttempts !== 1 ? 's' : ''} remaining`}
//       </Box>
//     );
//   };

//   const LockedScreen = () => (
//     <Box sx={{
//       textAlign: 'center',
//       padding: isMobile ? '1rem' : '1.5rem',
//       backgroundColor: '#fff9f9',
//       borderRadius: '8px',
//       border: '1px solid #ffebee'
//     }}>
//       <FontAwesomeIcon icon={faLockIcon} size={isMobile ? "2x" : "3x"} color="#d32f2f" />
//       <h3 style={{ marginTop: '1rem', color: '#d32f2f', fontSize: isMobile ? '1.2rem' : '1.4rem' }}>Account Locked</h3>
//       <p style={{ color: '#555', fontSize: isMobile ? '0.8rem' : '1rem' }}>Your account is temporarily locked due to multiple failed login attempts.</p>
//       {remainingTime && (
//         <Box sx={{
//           marginTop: '1rem',
//           padding: isMobile ? '0.6rem' : '0.8rem',
//           backgroundColor: '#ffebee',
//           borderRadius: '6px',
//           display: 'inline-block'
//         }}>
//           <p style={{
//             color: '#d32f2f',
//             fontSize: isMobile ? '1.2rem' : '1.4rem',
//             fontWeight: 'bold',
//             margin: 0
//           }}>
//             Please try again in {remainingTime.minutes}:{remainingTime.seconds.toString().padStart(2, '0')} minutes
//           </p>
//         </Box>
//       )}
//     </Box>
//   );

//   // Animation keyframes
//   const gradientAnimation = keyframes`
//     0% { background-position: 0% 50%; }
//     50% { background-position: 100% 50%; }
//     100% { background-position: 0% 50%; }
//   `;

//   const fadeIn = keyframes`
//     from { opacity: 0; transform: translateY(20px); }
//     to { opacity: 1; transform: translateY(0); }
//   `;

//   const floatAnimation = keyframes`
//     0% { transform: translateY(0px); }
//     25% { transform: translateY(-15px); }
//     50% { transform: translateY(0px); }
//     75% { transform: translateY(10px); }
//     100% { transform: translateY(0px); }
//   `;

//   const pulseAnimation = keyframes`
//     0% { transform: scale(1); }
//     50% { transform: scale(1.05); }
//     100% { transform: scale(1); }
//   `;

//   // Styles
//   const styles = {
//     loginContainer: {
//       width: '100%',
//       minHeight: '100vh',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       padding: isMobile ? '1rem' : isTablet ? '1.5rem' : '2rem',
//       margin: 0,
//       overflow: 'hidden',
//       position: 'relative',
//       backgroundColor: isMobile || isTablet ? '#e3f2fd' : 'transparent',
//       ...(!isMobile && !isTablet && {
//         background: 'linear-gradient(270deg, #f5f7fa, #c3cfe2, #a1c4fd, #c2e9fb)',
//         backgroundSize: '400% 400%',
//         animation: `${gradientAnimation} 15s ease infinite`,
//       }),
//     },
//     formContainer: {
//       width: '100%',
//       maxWidth: isMobile ? '320px' : isTablet ? '450px' : '400px',
//       padding: isMobile ? '1rem' : isTablet ? '1.5rem' : '1.5rem',
//       boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
//       borderRadius: '12px',
//       backgroundColor: 'rgba(255, 255, 255, 0.95)',
//       backdropFilter: 'blur(5px)',
//       //  animation: `${fadeIn} 0.6s ease-out`,
//       transform: 'translateZ(0)',
//       // transition: 'all 0.3s ease',
//       // '&:hover': !isMobile && !isTablet ? {
//       //   boxShadow: '0 15px 35px rgba(0,0,0,0.15)',
//       //   transform: 'translateY(-5px)'
//       // } : {},
//     },
//     logo: {
//       height: isMobile ? '8vh' : isTablet ? '10vh' : '12vh',
//       width: isMobile ? '8vh' : isTablet ? '10vh' : '12vh',
//       margin: '5px',
//       objectFit: 'contain',
//       filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
//       animation: `${pulseAnimation} 3s ease-in-out infinite`
//     },
//     title: {
//       fontSize: isMobile ? '1rem' : isTablet ? '1.2rem' : '1.4rem',
//       textAlign: 'center',
//       margin: '0.3rem 0',
//       color: '#444',
//       fontWeight: '600',
//       textShadow: '0 1px 2px rgba(0,0,0,0.1)'
//     },
//     subtitle: {
//       fontSize: isMobile ? '0.6rem' : isTablet ? '0.8rem' : '0.9rem',
//       textAlign: 'center',
//       fontStyle: 'italic',
//       color: '#555',
//       marginBottom: '0.5rem',
//       opacity: 0.8,
//       animation: `${fadeIn} 1s ease-out`
//     },
//     inputContainer: {
//       display: 'flex',
//       alignItems: 'center',
//       border: '1px solid rgba(0,0,0,0.1)',
//       borderRadius: '8px',
//       padding: isMobile ? '0.2rem' : '0.3rem',
//       marginBottom: '0.3rem',
//       width: '100%',
//       backgroundColor: 'rgba(255,255,255,0.8)',
//       transition: 'all 0.3s ease',
//       '&:focus-within': {
//         borderColor: '#4a90e2',
//         boxShadow: '0 0 0 2px rgba(74,144,226,0.2)'
//       }
//     },
//     captchaContainer: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       border: '1px solid rgba(0,0,0,0.1)',
//       borderRadius: '8px',
//       padding: isMobile ? '0.2rem' : '0.3rem',
//       marginBottom: '0.3rem',
//       width: '100%',
//       backgroundColor: 'rgba(255,255,255,0.8)',
//       transition: 'all 0.3s ease',
//       '&:focus-within': {
//         borderColor: '#4a90e2',
//         boxShadow: '0 0 0 2px rgba(74,144,226,0.2)'
//       },
//       transform: isMobile ? 'scale(0.85)' : isTablet ? 'scale(0.95)' : 'scale(1)',
//       transformOrigin: 'center',
//     },
//     input: {
//       flex: 1,
//       border: 'none',
//       outline: 'none',
//       fontSize: isMobile ? '0.7rem' : isTablet ? '0.8rem' : '0.9rem',
//       padding: isMobile ? '0.2rem' : '0.3rem',
//       backgroundColor: 'transparent',
//       '&::placeholder': {
//         color: '#aaa'
//       }
//     },
//     errorText: {
//       color: '#ff4444',
//       fontSize: isMobile ? '0.6rem' : '0.7rem',
//       marginTop: '-0.3rem',
//       marginBottom: '0.3rem',
//       textAlign: 'left',
//       width: '100%',
//       fontWeight: '500'
//     },
//     button: {
//       width: isMobile ? '100%' : isTablet ? '80%' : '60%',
//       margin: '0.3rem 0',
//       padding: isMobile ? '0.5rem' : '0.6rem',
//       borderRadius: '8px',
//       fontWeight: '600',
//       letterSpacing: '0.5px',
//       transition: 'all 0.3s ease',
//       '&:hover': {
//         transform: 'translateY(-2px)',
//         boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
//       }
//     },
//     imageSection: {
//       display: isMobile ? 'none' : 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       height: '100vh',
//       position: 'relative',
//       overflow: 'hidden',
//       '&::before': {
//         content: '""',
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
//         zIndex: 1
//       }
//     },
//     welcomeText: {
//       fontSize: isTablet ? '1.4rem' : '1.6rem',
//       color: '#333',
//       marginBottom: '0.8rem',
//       fontWeight: '700',
//       textShadow: '0 2px 4px rgba(0,0,0,0.1)',
//       animation: `${fadeIn} 0.8s ease-out`
//     },
//     description: {
//       fontSize: isTablet ? '0.9rem' : '1rem',
//       color: '#555',
//       lineHeight: '1.5',
//       maxWidth: isTablet ? '400px' : '450px',
//       opacity: 0.9,
//       animation: `${fadeIn} 1s ease-out`
//     },
//     backgroundAnimation: {
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       background: `radial-gradient(circle at ${backgroundPosition}, rgba(161,196,253,0.3) 0%, rgba(194,233,251,0.1) 50%, rgba(255,255,255,0) 100%)`,
//       transition: 'background-position 8s ease-out',
//       zIndex: 0
//     },
//     floatingImage: {
//       maxWidth: '100%',
//       height: 'auto',
//       maxHeight: isTablet ? '45vh' : '50vh',
//       filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.1))',
//       transform: imageHover ? 'perspective(1000px) rotateY(0deg) scale(1.05)' : 'perspective(1000px) rotateY(-5deg)',
//       transition: 'transform 0.5s ease, filter 0.3s ease',
//       animation: `${floatAnimation} 4s ease-in-out infinite`,
//       cursor: 'pointer'
//     }
//   };

//   return (
//     <>
//       {/* Splash Screen */}
//       {showSplash && (
//         <SplashScreen
//           duration={3000}
//           onComplete={() => {
//             // This will be called after splash screen completes
//             setShowSplash(false);
//           }}
//         />
//       )}

//       <Container maxWidth={false} sx={styles.loginContainer}>
//         <ToastContainer />
//         {!isMobile && !isTablet && <Box sx={styles.backgroundAnimation} />}

//         <Grid container sx={{
//           flexGrow: 1,
//           alignItems: 'center',
//           justifyContent: 'center',
//           position: 'relative',
//           zIndex: 1,
//           height: isMobile ? 'auto' : '100vh',
//           overflowY: isMobile ? 'auto' : 'visible'
//         }}>
//           {/* Image Section - Hidden on mobile and tablet */}
//           {!isMobile && !isTablet && (
//             <Grid item xs={12} md={6} sx={styles.imageSection}>
//               <Box sx={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 padding: '1rem',
//                 textAlign: 'center',
//                 position: 'relative',
//                 zIndex: 2
//               }}>
//                 <img
//                   alt="Document Management"
//                   src={advPics}
//                   style={styles.floatingImage as React.CSSProperties}
//                   onMouseEnter={() => setImageHover(true)}
//                   onMouseLeave={() => setImageHover(false)}
//                   onClick={() => setImageHover(!imageHover)}
//                 />
//                 <Box sx={{ marginTop: '1rem' }}>
//                   <h3 style={styles.welcomeText as React.CSSProperties}>Welcome to DDMSS</h3>
//                   <p style={styles.description as React.CSSProperties}>
//                     Streamline your document workflow with our comprehensive management system.
//                     Organize, track, and access your documents with ease and efficiency.
//                   </p>
//                 </Box>
//               </Box>
//             </Grid>
//           )}

//           {/* Form Section - Always centered */}
//           <Grid item xs={12} md={isMobile || isTablet ? 12 : 6} sx={{
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             padding: isMobile ? '0.5rem' : isTablet ? '1rem' : '1rem',
//             height: isMobile || isTablet ? 'auto' : 'auto',
//             overflowY: 'auto'
//           }}>
//             <Box sx={styles.formContainer}>
//               <Box sx={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 marginBottom: '1rem',
//               }}>
//                 <img
//                   alt="Logo"
//                   src={logo}
//                   style={styles.logo as React.CSSProperties}
//                 />
//                 <h3 style={styles.title as React.CSSProperties}>Digital Document Management System Software</h3>
//                 <i style={styles.subtitle as React.CSSProperties}>
//                   "Efficiency Unleashed: Your Documents, Organized!"
//                 </i>
//               </Box>

//               {/* Show locked screen if account is locked */}
//               {isAccountLocked ? (
//                 <LockedScreen />
//               ) : (
//                 <>
//                   <form onSubmit={(e) => {
//                     e.preventDefault();
//                     handleButtonClick();
//                   }}
//                     style={{
//                       width: '100%',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       alignItems: 'center',
//                     }}>
//                     <Box sx={{ marginBottom: '1rem', width: '100%' }}>
//                       <Box sx={styles.inputContainer}>
//                         <FontAwesomeIcon
//                           icon={faUser}
//                           style={{ color: '#4a90e2', margin: '0 5px' }}
//                         />
//                         <input
//                           type="text"
//                           name="useR_ID"
//                           autoComplete="off"
//                           id="useR_ID"
//                           value={formik.values.useR_ID}
//                           placeholder="Username"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           style={styles.input}
//                         />
//                       </Box>
//                       {formik.touched.useR_ID && formik.errors.useR_ID && (
//                         <div style={styles.errorText as React.CSSProperties}>{formik.errors.useR_ID}</div>
//                       )}

//                       <Box sx={styles.inputContainer}>
//                         <FontAwesomeIcon
//                           icon={faLock}
//                           style={{ color: '#4a90e2', margin: '0 5px' }}
//                         />
//                         <input
//                           type={showPassword ? "text" : "password"}
//                           name="password"
//                           autoComplete="off"
//                           id="password"
//                           value={formik.values.password}
//                           placeholder="Password"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           style={styles.input}
//                         />
//                         <FontAwesomeIcon
//                           icon={showPassword ? faEyeSlash : faEye}
//                           style={{ color: '#4a90e2', margin: '0 5px', cursor: 'pointer' }}
//                           onClick={() => setShowPassword(!showPassword)}
//                         />
//                       </Box>
//                       {formik.touched.password && formik.errors.password && (
//                         <div style={styles.errorText as React.CSSProperties}>{formik.errors.password}</div>
//                       )}

//                       {/* CAPTCHA Component */}
//                       <Box sx={styles.captchaContainer}>
//                         <ReCAPTCHA
//                           ref={recaptchaRef}
//                           sitekey="6Ld-3aYtAAAAAEqDhugv0bgAX43LhWKRSBde2c0-"
//                           onChange={handleCaptchaChange}
//                           onExpired={handleCaptchaExpired}
//                         />
//                       </Box>
//                       {formik.touched.gRecaptchaResponse && formik.errors.gRecaptchaResponse && (
//                         <div style={styles.errorText as React.CSSProperties}>{formik.errors.gRecaptchaResponse}</div>
//                       )}
//                     </Box>

//                     <Box sx={{
//                       display: 'flex',
//                       justifyContent: 'center',
//                       width: '100%',
//                     }}>
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         disabled={loading}
//                         sx={styles.button}
//                         onClick={handleButtonClick}
//                         type="submit"
//                       >
//                         {loading ? (
//                           <CircularProgress size={isMobile ? 20 : 24} style={{ color: "white" }} />
//                         ) : (
//                           "Sign In"
//                         )}
//                       </Button>
//                     </Box>
//                   </form>
//                   <AttemptsMessage />
//                 </>
//               )}
//             </Box>
//           </Grid>
//         </Grid>
//       </Container>
//     </>
//   );
// }

// export default LoginPage;







// import React, { useState, useRef, useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faUser, faLock, faEye, faEyeSlash, faLock as faLockIcon } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import HOST_URL from "../utils/Url";
// import useLocalStorage from "use-local-storage";
// import { Button, CircularProgress, Grid, Box, Container, useMediaQuery, useTheme } from "@mui/material";
// import { useFormik } from "formik";
// import { toast, ToastContainer } from "react-toastify";
// import * as Yup from 'yup';
// import advPics from '../assets/images/headDoc.png';
// import logo from '../assets/images/recyclebinLogo.png';
// import { keyframes } from "@emotion/react";
// import { secureSetItem, encryptData } from "../utils/encryption";
// import ReCAPTCHA from "react-google-recaptcha";
// import SplashScreen from "./SplashScreen"; // Import the splash screen

// // ✅ यहाँ Axios Response Interceptor लगाएं (कंपोनेंट के बाहर)
// axios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response && error.response.status === 401) {
//       // यदि बैकएंड से 401 Unauthorized (या इनवैलिड सेशन) आए, तो स्टोरेज साफ करें और लॉगिन पर भेजें
//       localStorage.clear();
//       sessionStorage.clear();
//       // note: window.location.href का उपयोग करके सीधे रिफ्रेश के साथ रीडायरेक्ट करें
//       if (window.location.pathname !== "/login") {
//         window.location.href = "/login";
//       }
//     }
//     return Promise.reject(error);
//   }
// );

// function LoginPage() {
//   const [remainingAttempts, setRemainingAttempts] = useState<number | null>(null);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
//   const isLaptop = useMediaQuery(theme.breakpoints.up('md'));
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);
//   const [unlockTime, setUnlockTime] = useState<Date | null>(null);
//   const [remainingTime, setRemainingTime] = useState<{ minutes: number; seconds: number } | null>(null);
//   const [isAccountLocked, setIsAccountLocked] = useState(false);
//   const timer = useRef<ReturnType<typeof setTimeout>>();
//   const recaptchaRef = useRef<ReCAPTCHA>(null);
//   const navigate = useNavigate();
//   const [tokenKey, setTokenKey] = useLocalStorage("name", "");
//   const [backgroundPosition, setBackgroundPosition] = useState("0% 0%");
//   const [imageHover, setImageHover] = useState(false);
//   const [showSplash, setShowSplash] = useState(false); // New state for splash screen

//   // Animated background effect
//   useEffect(() => {
//     if (!isMobile && !isTablet) {
//       const interval = setInterval(() => {
//         setBackgroundPosition(prev => {
//           const x = Math.floor(Math.random() * 100);
//           const y = Math.floor(Math.random() * 100);
//           return `${x}% ${y}%`;
//         });
//       }, 10000);
//       return () => clearInterval(interval);
//     }
//   }, [isMobile, isTablet]);

//   // Countdown timer effect
//   useEffect(() => {
//     if (unlockTime) {
//       const interval = setInterval(() => {
//         const now = new Date().getTime();
//         const diff = unlockTime.getTime() - now;
//         if (diff <= 0) {
//           clearInterval(interval);
//           setRemainingAttempts(null);
//           setUnlockTime(null);
//           setRemainingTime(null);
//           setIsAccountLocked(false);
//         } else {
//           const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
//           const seconds = Math.floor((diff % (1000 * 60)) / 1000);
//           setRemainingTime({ minutes, seconds });
//         }
//       }, 1000);
//       return () => clearInterval(interval);
//     }
//   }, [unlockTime]);

//   const parseUnlockTime = (lockTimeStrStr: string): Date => {
//     const timeMatch = lockTimeStrStr.match(/(\d{1,2}):(\d{2}) ([AP]M)/i);
//     if (timeMatch) {
//       const now = new Date();
//       let hours = parseInt(timeMatch[1]);
//       const minutes = parseInt(timeMatch[2]);
//       const ampm = timeMatch[3].toUpperCase();
//       if (ampm === 'PM' && hours !== 12) hours += 12;
//       if (ampm === 'AM' && hours === 12) hours = 0;
//       const unlock = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0);
//       if (unlock < now) unlock.setDate(unlock.getDate() + 1);
//       return unlock;
//     } else {
//       const durationMatch = lockTimeStrStr.match(/(\d+)\s*minutes?/i);
//       if (durationMatch) {
//         const min = parseInt(durationMatch[1]);
//         return new Date(new Date().getTime() + min * 60000);
//       }
//     }
//     // Default to 15 minutes
//     return new Date(new Date().getTime() + 15 * 60000);
//   };

//   const validationSchema = Yup.object({
//     useR_ID: Yup.string()
//       .required("Username is required"),
//     password: Yup.string()
//       .required("Password is required"),
//        gRecaptchaResponse: Yup.string()
//    .required("Please complete the CAPTCHA"),
//   });

//   const formik = useFormik({
//     initialValues: {
//       useR_ID: "",
//       password: "",
//       collageID: "1",
//       packageID: "1",
//       gRecaptchaResponse: "",
//     },
//     validationSchema: validationSchema,
//     onSubmit: () => { }, // Empty function since we handle submission manually
//   });

//   const handleCaptchaChange = (token: string | null) => {
//     formik.setFieldValue("gRecaptchaResponse", token || "");
//   };

//   const handleCaptchaExpired = () => {
//     formik.setFieldValue("gRecaptchaResponse", "");
//   };

//   const resetCaptcha = () => {
//     recaptchaRef.current?.reset();
//     formik.setFieldValue("gRecaptchaResponse", "");
//   };

//   const handleButtonClick = async () => {
//     if (!loading) {
//       setSuccess(false);
//       setLoading(true);
//       let hasError = false;
//       try {
//         await formik.validateForm();
//         if (Object.keys(formik.errors).length === 0) {
          
//           // 🛡️ Anti-Replay Security: Har naye request ke sath unique timestamp aur nonce jodein
//           const nonce = Math.random().toString(36).substring(2, 15);
          
//           // Encrypt the sensitive data before sending
//           const encryptedPayload = {
//             useR_ID: encryptData(formik.values.useR_ID),
//             password: encryptData(formik.values.password),
//             collageID: formik.values.collageID,
//             packageID: formik.values.packageID,
//             gRecaptchaResponse: formik.values.gRecaptchaResponse,
//             timestamp: Date.now(),
//             nonce: nonce           
//           };

//           // Send the encrypted payload directly
//           const response = await axios.post(HOST_URL.HOST_URL + `USER/USERLOGIN`, encryptedPayload);

//           // 🛡️ सुरक्षा सुधार: isSuccess के साथ-साथ वैध token की मौजूदगी भी अनिवार्य है
//           if (response.data.isSuccess && response.data.data && response.data.data[0]["token"]) {
//             if (response.data.data[0]["userPermission"] == null) {
//               toast.error("User Permission is null");
//               hasError = true;
//               setLoading(false);
//             } else {
//               // Use secure storage instead of localStorage
//               secureSetItem("userdata", response.data.data);
//               secureSetItem("useR_ID", response.data.data[0]["userdetail"][0]["useR_ID"]);
//               secureSetItem("devID", response.data.data[0]["userdetail"][0]["departmentId"]);
//               secureSetItem("devName", response.data.data[0]["userdetail"][0]["department_Name"]);
//               secureSetItem("subDeptID", response.data.data[0]["userdetail"][0]["subDeptID"]);

//               // For sessionStorage
//               sessionStorage.setItem("token", response.data.data[0]["token"]);

//               // Show splash screen before navigation
//               setShowSplash(true);

//               // Delay navigation to show splash screen
//               setTimeout(() => {
//                 navigate(`/home`);
//                 toast.success(response.data.mesg || "Login successful");
//                 formik.resetForm();
//                 resetCaptcha(); // Successful login par bhi captcha clear karein
//                 setRemainingAttempts(null);
//                 setUnlockTime(null);
//                 setIsAccountLocked(false);
//                 setShowSplash(false);
//               }, 3000);

//               timer.current = setTimeout(() => {
//                 setSuccess(true);
//                 setLoading(false);
//               }, 1000);
//             }

//           } else {
//             hasError = true;
//             const errorMessage = response.data.mesg || "Invalid authentication response or missing security token.";

//             if (errorMessage === "Invalid credentials") {
//               setRemainingAttempts(prev => {
//                 const newAttempts = prev !== null ? Math.max(0, prev - 1) : 4;
//                 toast.error(`Invalid credentials. You have ${newAttempts} attempt${newAttempts !== 1 ? 's' : ''} remaining`);
//                 return newAttempts;
//               });
//             } else if (errorMessage.includes("attempt") || errorMessage.includes("attempts")) {
//               const attemptsMatch = errorMessage.match(/(\d+)\s+attempt/);
//               if (attemptsMatch && attemptsMatch[1]) {
//                 setRemainingAttempts(parseInt(attemptsMatch[1]));
//               } else {
//                 setRemainingAttempts(prev => prev !== null ? Math.max(0, prev - 1) : 4);
//               }
//               toast.error(errorMessage);
//             } else if (errorMessage.includes("locked") || errorMessage.includes("Try again after")) {
//               const timeMatch = errorMessage.match(/Try again after\s+(.*)$/);
//               const lockTimeStr = timeMatch ? timeMatch[1] : "15 minutes";
//               const parsedUnlockTime = parseUnlockTime(lockTimeStr);
//               setUnlockTime(parsedUnlockTime);
//               setIsAccountLocked(true);
//               toast.error(errorMessage);
//               setRemainingAttempts(0);
//             } else {
//               toast.error(errorMessage);
//             }

//             setLoading(false);
//           }
//         } else {
//           hasError = true;
//           setLoading(false);
//         }
//       } catch (error: any) {
//         hasError = true;
//         // Handle axios errors
//         if (error.response && error.response.data) {
//           const errorData = error.response.data;
//           const errorMessage = errorData.mesg || "Login Failed";

//           if (errorMessage === "Invalid credentials") {
//             setRemainingAttempts(prev => {
//               const newAttempts = prev !== null ? Math.max(0, prev - 1) : 4;
//               toast.error(`Invalid credentials. You have ${newAttempts} attempt${newAttempts !== 1 ? 's' : ''} remaining`);
//               return newAttempts;
//             });
//           } else if (errorMessage.includes("attempt") || errorMessage.includes("attempts")) {
//             const attemptsMatch = errorMessage.match(/(\d+)\s+attempt/);
//             if (attemptsMatch && attemptsMatch[1]) {
//               setRemainingAttempts(parseInt(attemptsMatch[1]));
//             }
//             toast.error(errorMessage);
//           } else if (errorMessage.includes("locked") || errorMessage.includes("Try again after")) {
//             const timeMatch = errorMessage.match(/Try again after\s+(.*)$/);
//             const lockTimeStr = timeMatch ? timeMatch[1] : "15 minutes";
//             const parsedUnlockTime = parseUnlockTime(lockTimeStr);
//             setUnlockTime(parsedUnlockTime);
//             setIsAccountLocked(true);
//             toast.error(errorMessage);
//             setRemainingAttempts(0);
//           } else {
//             toast.error(errorMessage);
//           }
//         } else {
//           toast.error("Login Failed");
//         }
//         setLoading(false);
//       } finally {
//         // 🛡️ Security Fix: Har fail ya error hone par reCAPTCHA aur password field ko force reset karein
//         resetCaptcha();
//         formik.setFieldValue("password", ""); // Password field turant clear ho jaye
//         if (hasError) {
//           setLoading(false);
//         }
//       }
//     }
//   };

//   const AttemptsMessage = () => {
//     if (remainingAttempts === null || remainingAttempts === 0) return null;

//     return (
//       <Box sx={{
//         width: '100%',
//         textAlign: 'center',
//         marginTop: '0.5rem',
//         padding: '0.3rem',
//         borderRadius: '4px',
//         backgroundColor: remainingAttempts > 2 ? '#e8f5e8' :
//           remainingAttempts > 1 ? '#fff3cd' : '#f8d7da',
//         color: remainingAttempts > 2 ? '#2e7d32' :
//           remainingAttempts > 1 ? '#856404' : '#721c24',
//         fontSize: isMobile ? '0.7rem' : '0.8rem',
//         fontWeight: '500'
//       }}>
//         {`You have ${remainingAttempts} attempt${remainingAttempts !== 1 ? 's' : ''} remaining`}
//       </Box>
//     );
//   };

//   const LockedScreen = () => (
//     <Box sx={{
//       textAlign: 'center',
//       padding: isMobile ? '1rem' : '1.5rem',
//       backgroundColor: '#fff9f9',
//       borderRadius: '8px',
//       border: '1px solid #ffebee'
//     }}>
//       <FontAwesomeIcon icon={faLockIcon} size={isMobile ? "2x" : "3x"} color="#d32f2f" />
//       <h3 style={{ marginTop: '1rem', color: '#d32f2f', fontSize: isMobile ? '1.2rem' : '1.4rem' }}>Account Locked</h3>
//       <p style={{ color: '#555', fontSize: isMobile ? '0.8rem' : '1rem' }}>Your account is temporarily locked due to multiple failed login attempts.</p>
//       {remainingTime && (
//         <Box sx={{
//           marginTop: '1rem',
//           padding: isMobile ? '0.6rem' : '0.8rem',
//           backgroundColor: '#ffebee',
//           borderRadius: '6px',
//           display: 'inline-block'
//         }}>
//           <p style={{
//             color: '#d32f2f',
//             fontSize: isMobile ? '1.2rem' : '1.4rem',
//             fontWeight: 'bold',
//             margin: 0
//           }}>
//             Please try again in {remainingTime.minutes}:{remainingTime.seconds.toString().padStart(2, '0')} minutes
//           </p>
//         </Box>
//       )}
//     </Box>
//   );

//   // Animation keyframes
//   const gradientAnimation = keyframes`
//     0% { background-position: 0% 50%; }
//     50% { background-position: 100% 50%; }
//     100% { background-position: 0% 50%; }
//   `;

//   const fadeIn = keyframes`
//     from { opacity: 0; transform: translateY(20px); }
//     to { opacity: 1; transform: translateY(0); }
//   `;

//   const floatAnimation = keyframes`
//     0% { transform: translateY(0px); }
//     25% { transform: translateY(-15px); }
//     50% { transform: translateY(0px); }
//     75% { transform: translateY(10px); }
//     100% { transform: translateY(0px); }
//   `;

//   const pulseAnimation = keyframes`
//     0% { transform: scale(1); }
//     50% { transform: scale(1.05); }
//     100% { transform: scale(1); }
//   `;

//   // Styles
//   const styles = {
//     loginContainer: {
//       width: '100%',
//       minHeight: '100vh',
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       padding: isMobile ? '1rem' : isTablet ? '1.5rem' : '2rem',
//       margin: 0,
//       overflow: 'hidden',
//       position: 'relative',
//       backgroundColor: isMobile || isTablet ? '#e3f2fd' : 'transparent',
//       ...(!isMobile && !isTablet && {
//         background: 'linear-gradient(270deg, #f5f7fa, #c3cfe2, #a1c4fd, #c2e9fb)',
//         backgroundSize: '400% 400%',
//         animation: `${gradientAnimation} 15s ease infinite`,
//       }),
//     },
//     formContainer: {
//       width: '100%',
//       maxWidth: isMobile ? '320px' : isTablet ? '450px' : '400px',
//       padding: isMobile ? '1rem' : isTablet ? '1.5rem' : '1.5rem',
//       boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
//       borderRadius: '12px',
//       backgroundColor: 'rgba(255, 255, 255, 0.95)',
//       backdropFilter: 'blur(5px)',
//       transform: 'translateZ(0)',
//     },
//     logo: {
//       height: isMobile ? '8vh' : isTablet ? '10vh' : '12vh',
//       width: isMobile ? '8vh' : isTablet ? '10vh' : '12vh',
//       margin: '5px',
//       objectFit: 'contain',
//       filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
//       animation: `${pulseAnimation} 3s ease-in-out infinite`
//     },
//     title: {
//       fontSize: isMobile ? '1rem' : isTablet ? '1.2rem' : '1.4rem',
//       textAlign: 'center',
//       margin: '0.3rem 0',
//       color: '#444',
//       fontWeight: '600',
//       textShadow: '0 1px 2px rgba(0,0,0,0.1)'
//     },
//     subtitle: {
//       fontSize: isMobile ? '0.6rem' : isTablet ? '0.8rem' : '0.9rem',
//       textAlign: 'center',
//       fontStyle: 'italic',
//       color: '#555',
//       marginBottom: '0.5rem',
//       opacity: 0.8,
//       animation: `${fadeIn} 1s ease-out`
//     },
//     inputContainer: {
//       display: 'flex',
//       alignItems: 'center',
//       border: '1px solid rgba(0,0,0,0.1)',
//       borderRadius: '8px',
//       padding: isMobile ? '0.2rem' : '0.3rem',
//       marginBottom: '0.3rem',
//       width: '100%',
//       backgroundColor: 'rgba(255,255,255,0.8)',
//       transition: 'all 0.3s ease',
//       '&:focus-within': {
//         borderColor: '#4a90e2',
//         boxShadow: '0 0 0 2px rgba(74,144,226,0.2)'
//       }
//     },
//     captchaContainer: {
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//       border: '1px solid rgba(0,0,0,0.1)',
//       borderRadius: '8px',
//       padding: isMobile ? '0.2rem' : '0.3rem',
//       marginBottom: '0.3rem',
//       width: '100%',
//       backgroundColor: 'rgba(255,255,255,0.8)',
//       transition: 'all 0.3s ease',
//       '&:focus-within': {
//         borderColor: '#4a90e2',
//         boxShadow: '0 0 0 2px rgba(74,144,226,0.2)'
//       },
//       transform: isMobile ? 'scale(0.85)' : isTablet ? 'scale(0.95)' : 'scale(1)',
//       transformOrigin: 'center',
//     },
//     input: {
//       flex: 1,
//       border: 'none',
//       outline: 'none',
//       fontSize: isMobile ? '0.7rem' : isTablet ? '0.8rem' : '0.9rem',
//       padding: isMobile ? '0.2rem' : '0.3rem',
//       backgroundColor: 'transparent',
//       '&::placeholder': {
//         color: '#aaa'
//       }
//     },
//     errorText: {
//       color: '#ff4444',
//       fontSize: isMobile ? '0.6rem' : '0.7rem',
//       marginTop: '-0.3rem',
//       marginBottom: '0.3rem',
//       textAlign: 'left',
//       width: '100%',
//       fontWeight: '500'
//     },
//     button: {
//       width: isMobile ? '100%' : isTablet ? '80%' : '60%',
//       margin: '0.3rem 0',
//       padding: isMobile ? '0.5rem' : '0.6rem',
//       borderRadius: '8px',
//       fontWeight: '600',
//       letterSpacing: '0.5px',
//       transition: 'all 0.3s ease',
//       '&:hover': {
//         transform: 'translateY(-2px)',
//         boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
//       }
//     },
//     imageSection: {
//       display: isMobile ? 'none' : 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       height: '100vh',
//       position: 'relative',
//       overflow: 'hidden',
//       '&::before': {
//         content: '""',
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
//         zIndex: 1
//       }
//     },
//     welcomeText: {
//       fontSize: isTablet ? '1.4rem' : '1.6rem',
//       color: '#333',
//       marginBottom: '0.8rem',
//       fontWeight: '700',
//       textShadow: '0 2px 4px rgba(0,0,0,0.1)',
//       animation: `${fadeIn} 0.8s ease-out`
//     },
//     description: {
//       fontSize: isTablet ? '0.9rem' : '1rem',
//       color: '#555',
//       lineHeight: '1.5',
//       maxWidth: isTablet ? '400px' : '450px',
//       opacity: 0.9,
//       animation: `${fadeIn} 1s ease-out`
//     },
//     backgroundAnimation: {
//       position: 'absolute',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       background: `radial-gradient(circle at ${backgroundPosition}, rgba(161,196,253,0.3) 0%, rgba(194,233,251,0.1) 50%, rgba(255,255,255,0) 100%)`,
//       transition: 'background-position 8s ease-out',
//       zIndex: 0
//     },
//     floatingImage: {
//       maxWidth: '100%',
//       height: 'auto',
//       maxHeight: isTablet ? '45vh' : '50vh',
//       filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.1))',
//       transform: imageHover ? 'perspective(1000px) rotateY(0deg) scale(1.05)' : 'perspective(1000px) rotateY(-5deg)',
//       transition: 'transform 0.5s ease, filter 0.3s ease',
//       animation: `${floatAnimation} 4s ease-in-out infinite`,
//       cursor: 'pointer'
//     }
//   };

//   return (
//     <>
//       {/* Splash Screen */}
//       {showSplash && (
//         <SplashScreen
//           duration={3000}
//           onComplete={() => {
//             setShowSplash(false);
//           }}
//         />
//       )}

//       <Container maxWidth={false} sx={styles.loginContainer}>
//         <ToastContainer />
//         {!isMobile && !isTablet && <Box sx={styles.backgroundAnimation} />}

//         <Grid container sx={{
//           flexGrow: 1,
//           alignItems: 'center',
//           justifyContent: 'center',
//           position: 'relative',
//           zIndex: 1,
//           height: isMobile ? 'auto' : '100vh',
//           overflowY: isMobile ? 'auto' : 'visible'
//         }}>
//           {/* Image Section - Hidden on mobile and tablet */}
//           {!isMobile && !isTablet && (
//             <Grid item xs={12} md={6} sx={styles.imageSection}>
//               <Box sx={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 padding: '1rem',
//                 textAlign: 'center',
//                 position: 'relative',
//                 zIndex: 2
//               }}>
//                 <img
//                   alt="Document Management"
//                   src={advPics}
//                   style={styles.floatingImage as React.CSSProperties}
//                   onMouseEnter={() => setImageHover(true)}
//                   onMouseLeave={() => setImageHover(false)}
//                   onClick={() => setImageHover(!imageHover)}
//                 />
//                 <Box sx={{ marginTop: '1rem' }}>
//                   <h3 style={styles.welcomeText as React.CSSProperties}>Welcome to DDMSS</h3>
//                   <p style={styles.description as React.CSSProperties}>
//                     Streamline your document workflow with our comprehensive management system.
//                     Organize, track, and access your documents with ease and efficiency.
//                   </p>
//                 </Box>
//               </Box>
//             </Grid>
//           )}

//           {/* Form Section - Always centered */}
//           <Grid item xs={12} md={isMobile || isTablet ? 12 : 6} sx={{
//             display: 'flex',
//             justifyContent: 'center',
//             alignItems: 'center',
//             padding: isMobile ? '0.5rem' : isTablet ? '1rem' : '1rem',
//             height: isMobile || isTablet ? 'auto' : 'auto',
//             overflowY: 'auto'
//           }}>
//             <Box sx={styles.formContainer}>
//               <Box sx={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 marginBottom: '1rem',
//               }}>
//                 <img
//                   alt="Logo"
//                   src={logo}
//                   style={styles.logo as React.CSSProperties}
//                 />
//                 <h3 style={styles.title as React.CSSProperties}>Digital Document Management System Software</h3>
//                 <i style={styles.subtitle as React.CSSProperties}>
//                   "Efficiency Unleashed: Your Documents, Organized!"
//                 </i>
//               </Box>

//               {/* Show locked screen if account is locked */}
//               {isAccountLocked ? (
//                 <LockedScreen />
//               ) : (
//                 <>
//                   <form onSubmit={(e) => {
//                     e.preventDefault();
//                     handleButtonClick();
//                   }}
//                     style={{
//                       width: '100%',
//                       display: 'flex',
//                       flexDirection: 'column',
//                       alignItems: 'center',
//                     }}>
//                     <Box sx={{ marginBottom: '1rem', width: '100%' }}>
//                       <Box sx={styles.inputContainer}>
//                         <FontAwesomeIcon
//                           icon={faUser}
//                           style={{ color: '#4a90e2', margin: '0 5px' }}
//                         />
//                         <input
//                           type="text"
//                           name="useR_ID"
//                           autoComplete="off"
//                           id="useR_ID"
//                           value={formik.values.useR_ID}
//                           placeholder="Username"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           style={styles.input}
//                         />
//                       </Box>
//                       {formik.touched.useR_ID && formik.errors.useR_ID && (
//                         <div style={styles.errorText as React.CSSProperties}>{formik.errors.useR_ID}</div>
//                       )}

//                       <Box sx={styles.inputContainer}>
//                         <FontAwesomeIcon
//                           icon={faLock}
//                           style={{ color: '#4a90e2', margin: '0 5px' }}
//                         />
//                         <input
//                           type={showPassword ? "text" : "password"}
//                           name="password"
//                           autoComplete="off"
//                           id="password"
//                           value={formik.values.password}
//                           placeholder="Password"
//                           onChange={formik.handleChange}
//                           onBlur={formik.handleBlur}
//                           style={styles.input}
//                         />
//                         <FontAwesomeIcon
//                           icon={showPassword ? faEyeSlash : faEye}
//                           style={{ color: '#4a90e2', margin: '0 5px', cursor: 'pointer' }}
//                           onClick={() => setShowPassword(!showPassword)}
//                         />
//                       </Box>
//                       {formik.touched.password && formik.errors.password && (
//                         <div style={styles.errorText as React.CSSProperties}>{formik.errors.password}</div>
//                       )}

//                       {/* CAPTCHA Component */}
//                       <Box sx={styles.captchaContainer}>
//                         <ReCAPTCHA
//                           ref={recaptchaRef}
//                           sitekey="6Ld-3aYtAAAAAEqDhugv0bgAX43LhWKRSBde2c0-"
//                           onChange={handleCaptchaChange}
//                           onExpired={handleCaptchaExpired}
//                         />
//                       </Box>
//                       {formik.touched.gRecaptchaResponse && formik.errors.gRecaptchaResponse && (
//                         <div style={styles.errorText as React.CSSProperties}>{formik.errors.gRecaptchaResponse}</div>
//                       )}
//                     </Box>

//                     <Box sx={{
//                       display: 'flex',
//                       justifyContent: 'center',
//                       width: '100%',
//                     }}>
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         disabled={loading}
//                         sx={styles.button}
//                         onClick={handleButtonClick}
//                         type="submit"
//                       >
//                         {loading ? (
//                           <CircularProgress size={isMobile ? 20 : 24} style={{ color: "white" }} />
//                         ) : (
//                           "Sign In"
//                         )}
//                       </Button>
//                     </Box>
//                   </form>
//                   <AttemptsMessage />
//                 </>
//               )}
//             </Box>
//           </Grid>
//         </Grid>
//       </Container>
//     </>
//   );
// }

// export default LoginPage;




import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faLock, faEye, faEyeSlash, faLock as faLockIcon } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HOST_URL from "../utils/Url";
import useLocalStorage from "use-local-storage";
import { Button, CircularProgress, Grid, Box, Container, useMediaQuery, useTheme } from "@mui/material";
import { useFormik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import * as Yup from 'yup';
import advPics from '../assets/images/headDoc.png';
import logo from '../assets/images/recyclebinLogo.png';
import { keyframes } from "@emotion/react";
import { secureSetItem, encryptData } from "../utils/encryption";
import ReCAPTCHA from "react-google-recaptcha";
import SplashScreen from "./SplashScreen";

// ✅ 1. Request Interceptor: Protected APIs ke liye Bearer Token bhejein
axios.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token && !config.url?.includes("USERLOGIN")) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ 2. Response Interceptor (सिर्फ इसमें बदलाव करें):
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // 🛡️ 1. अगर रिक्वेस्ट LOGIN की है, तो पेज को बिल्कुल रिफ्रेश मत करो
    const requestUrl = error.config?.url?.toLowerCase() || "";
    if (requestUrl.includes("userlogin")) {
      return Promise.reject(error); // यह LoginPage को एरर टोस्ट दिखाने देगा
    }

    // 🛡️ 2. अगर यूजर पहले से लॉगिन पेज पर ही है, तो भी रिफ्रेश मत करो
    const currentPath = window.location.pathname.toLowerCase();
    if (currentPath === "/login" || currentPath === "/") {
      return Promise.reject(error);
    }

    // 🛡️ 3. सिर्फ तभी लॉगआउट/रिफ्रेश करो जब यूजर डैशबोर्ड या अंदर के किसी पेज पर हो और 401 आए
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

function LoginPage() {
  const [remainingAttempts, setRemainingAttempts] = useState<number | null>(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isLaptop = useMediaQuery(theme.breakpoints.up('md'));
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [unlockTime, setUnlockTime] = useState<Date | null>(null);
  const [remainingTime, setRemainingTime] = useState<{ minutes: number; seconds: number } | null>(null);
  const [isAccountLocked, setIsAccountLocked] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout>>();
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const navigate = useNavigate();
  const [tokenKey, setTokenKey] = useLocalStorage("name", "");
  const [backgroundPosition, setBackgroundPosition] = useState("0% 0%");
  const [imageHover, setImageHover] = useState(false);
  const [showSplash, setShowSplash] = useState(false);

  // 🛡️ Localhost par Google Test Key chalegi (Green tick), Live domain par Original key
  const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const recaptchaSiteKey = isLocalhost
    ? "6LcBasQrAAAAAFors9vxneugK4N82CUfqhm763YB"
    : "6LcBasQrAAAAAFors9vxneugK4N82CUfqhm763YB";

    // 6LcBasQrAAAAAFors9vxneugK4N82CUfqhm763YB   ---main web key hai
  // Animated background effect
  useEffect(() => {
    if (!isMobile && !isTablet) {
      const interval = setInterval(() => {
        setBackgroundPosition(prev => {
          const x = Math.floor(Math.random() * 100);
          const y = Math.floor(Math.random() * 100);
          return `${x}% ${y}%`;
        });
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [isMobile, isTablet]);

  // Countdown timer effect
  useEffect(() => {
    if (unlockTime) {
      const interval = setInterval(() => {
        const now = new Date().getTime();
        const diff = unlockTime.getTime() - now;
        if (diff <= 0) {
          clearInterval(interval);
          setRemainingAttempts(null);
          setUnlockTime(null);
          setRemainingTime(null);
          setIsAccountLocked(false);
        } else {
          const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((diff % (1000 * 60)) / 1000);
          setRemainingTime({ minutes, seconds });
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [unlockTime]);

  const parseUnlockTime = (lockTimeStrStr: string): Date => {
    const timeMatch = lockTimeStrStr.match(/(\d{1,2}):(\d{2}) ([AP]M)/i);
    if (timeMatch) {
      const now = new Date();
      let hours = parseInt(timeMatch[1]);
      const minutes = parseInt(timeMatch[2]);
      const ampm = timeMatch[3].toUpperCase();
      if (ampm === 'PM' && hours !== 12) hours += 12;
      if (ampm === 'AM' && hours === 12) hours = 0;
      const unlock = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0);
      if (unlock < now) unlock.setDate(unlock.getDate() + 1);
      return unlock;
    } else {
      const durationMatch = lockTimeStrStr.match(/(\d+)\s*minutes?/i);
      if (durationMatch) {
        const min = parseInt(durationMatch[1]);
        return new Date(new Date().getTime() + min * 60000);
      }
    }
    return new Date(new Date().getTime() + 15 * 60000);
  };

  const validationSchema = Yup.object({
    useR_ID: Yup.string().required("Username is required"),
    password: Yup.string().required("Password is required"),
    gRecaptchaResponse: Yup.string().required("Please complete the CAPTCHA"),
  });

  const formik = useFormik({
    initialValues: {
      useR_ID: "",
      password: "",
      collageID: "1",
      packageID: "1",
      gRecaptchaResponse: "",
    },
    validationSchema: validationSchema,
    onSubmit: () => { },
  });

  const handleCaptchaChange = (token: string | null) => {
    formik.setFieldValue("gRecaptchaResponse", token || "");
  };

  const handleCaptchaExpired = () => {
    formik.setFieldValue("gRecaptchaResponse", "");
  };

  const resetCaptcha = () => {
    recaptchaRef.current?.reset();
    formik.setFieldValue("gRecaptchaResponse", "");
  };

  const handleButtonClick = async () => {
    if (!loading) {
      setSuccess(false);
      setLoading(true);
      let hasError = false;
      try {
        await formik.validateForm();
        if (Object.keys(formik.errors).length === 0) {
          
          const nonce = Math.random().toString(36).substring(2, 15);
          
          const encryptedPayload = {
            useR_ID: encryptData(formik.values.useR_ID.trim()),
            password: encryptData(formik.values.password),
            collageID: formik.values.collageID,
            packageID: formik.values.packageID,
            gRecaptchaResponse: formik.values.gRecaptchaResponse,
            timestamp: Date.now(),
            nonce: nonce           
          };

          const response = await axios.post(HOST_URL.HOST_URL + `USER/USERLOGIN`, encryptedPayload);

          // 🛡️ VAPT Fix: isSuccess aur valid token dono hone anivarya hain
          if (
            response.data.isSuccess && 
            response.data.data && 
            response.data.data[0] && 
            response.data.data[0]["token"]
          ) {
            if (response.data.data[0]["userPermission"] == null) {
              toast.error("User Permission is null");
              hasError = true;
              setLoading(false);
            } else {
              secureSetItem("userdata", response.data.data);
              secureSetItem("useR_ID", response.data.data[0]["userdetail"][0]["useR_ID"]);
              secureSetItem("devID", response.data.data[0]["userdetail"][0]["departmentId"]);
              secureSetItem("devName", response.data.data[0]["userdetail"][0]["department_Name"]);
              secureSetItem("subDeptID", response.data.data[0]["userdetail"][0]["subDeptID"]);

              sessionStorage.setItem("token", response.data.data[0]["token"]);

              setShowSplash(true);

              setTimeout(() => {
                navigate(`/home`);
                toast.success(response.data.mesg || "Login successful");
                formik.resetForm();
                resetCaptcha();
                setRemainingAttempts(null);
                setUnlockTime(null);
                setIsAccountLocked(false);
                setShowSplash(false);
              }, 2000);

              timer.current = setTimeout(() => {
                setSuccess(true);
                setLoading(false);
              }, 1000);
            }

          } else {
            hasError = true;
            const errorMessage = response.data.mesg || "Invalid authentication response or missing security token.";

            if (errorMessage === "Invalid credentials") {
              setRemainingAttempts(prev => {
                const newAttempts = prev !== null ? Math.max(0, prev - 1) : 4;
                toast.error(`Invalid credentials. You have ${newAttempts} attempt${newAttempts !== 1 ? 's' : ''} remaining`);
                return newAttempts;
              });
            } else if (errorMessage.includes("attempt") || errorMessage.includes("attempts")) {
              const attemptsMatch = errorMessage.match(/(\d+)\s+attempt/);
              if (attemptsMatch && attemptsMatch[1]) {
                setRemainingAttempts(parseInt(attemptsMatch[1]));
              } else {
                setRemainingAttempts(prev => prev !== null ? Math.max(0, prev - 1) : 4);
              }
              toast.error(errorMessage);
            } else if (errorMessage.includes("locked") || errorMessage.includes("Try again after")) {
              const timeMatch = errorMessage.match(/Try again after\s+(.*)$/);
              const lockTimeStr = timeMatch ? timeMatch[1] : "15 minutes";
              const parsedUnlockTime = parseUnlockTime(lockTimeStr);
              setUnlockTime(parsedUnlockTime);
              setIsAccountLocked(true);
              toast.error(errorMessage);
              setRemainingAttempts(0);
            } else {
              toast.error(errorMessage);
            }

            setLoading(false);
          }
        } else {
          hasError = true;
          setLoading(false);
        }
      } catch (error: any) {
        hasError = true;
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          const errorMessage = errorData.mesg || "Login Failed";

          if (errorMessage === "Invalid credentials") {
            setRemainingAttempts(prev => {
              const newAttempts = prev !== null ? Math.max(0, prev - 1) : 4;
              toast.error(`Invalid credentials. You have ${newAttempts} attempt${newAttempts !== 1 ? 's' : ''} remaining`);
              return newAttempts;
            });
          } else if (errorMessage.includes("attempt") || errorMessage.includes("attempts")) {
            const attemptsMatch = errorMessage.match(/(\d+)\s+attempt/);
            if (attemptsMatch && attemptsMatch[1]) {
              setRemainingAttempts(parseInt(attemptsMatch[1]));
            }
            toast.error(errorMessage);
          } else if (errorMessage.includes("locked") || errorMessage.includes("Try again after")) {
            const timeMatch = errorMessage.match(/Try again after\s+(.*)$/);
            const lockTimeStr = timeMatch ? timeMatch[1] : "15 minutes";
            const parsedUnlockTime = parseUnlockTime(lockTimeStr);
            setUnlockTime(parsedUnlockTime);
            setIsAccountLocked(true);
            toast.error(errorMessage);
            setRemainingAttempts(0);
          } else {
            toast.error(errorMessage);
          }
        } else {
          toast.error("Login Failed. Please check network/credentials.");
        }
        setLoading(false);
      } finally {
        resetCaptcha();
        if (hasError) {
          setLoading(false);
        }
      }
    }
  };

  const AttemptsMessage = () => {
    if (remainingAttempts === null || remainingAttempts === 0) return null;

    return (
      <Box sx={{
        width: '100%',
        textAlign: 'center',
        marginTop: '0.5rem',
        padding: '0.3rem',
        borderRadius: '4px',
        backgroundColor: remainingAttempts > 2 ? '#e8f5e8' :
          remainingAttempts > 1 ? '#fff3cd' : '#f8d7da',
        color: remainingAttempts > 2 ? '#2e7d32' :
          remainingAttempts > 1 ? '#856404' : '#721c24',
        fontSize: isMobile ? '0.7rem' : '0.8rem',
        fontWeight: '500'
      }}>
        {`You have ${remainingAttempts} attempt${remainingAttempts !== 1 ? 's' : ''} remaining`}
      </Box>
    );
  };

  const LockedScreen = () => (
    <Box sx={{
      textAlign: 'center',
      padding: isMobile ? '1rem' : '1.5rem',
      backgroundColor: '#fff9f9',
      borderRadius: '8px',
      border: '1px solid #ffebee'
    }}>
      <FontAwesomeIcon icon={faLockIcon} size={isMobile ? "2x" : "3x"} color="#d32f2f" />
      <h3 style={{ marginTop: '1rem', color: '#d32f2f', fontSize: isMobile ? '1.2rem' : '1.4rem' }}>Account Locked</h3>
      <p style={{ color: '#555', fontSize: isMobile ? '0.8rem' : '1rem' }}>Your account is temporarily locked due to multiple failed login attempts.</p>
      {remainingTime && (
        <Box sx={{
          marginTop: '1rem',
          padding: isMobile ? '0.6rem' : '0.8rem',
          backgroundColor: '#ffebee',
          borderRadius: '6px',
          display: 'inline-block'
        }}>
          <p style={{
            color: '#d32f2f',
            fontSize: isMobile ? '1.2rem' : '1.4rem',
            fontWeight: 'bold',
            margin: 0
          }}>
            Please try again in {remainingTime.minutes}:{remainingTime.seconds.toString().padStart(2, '0')} minutes
          </p>
        </Box>
      )}
    </Box>
  );

  const gradientAnimation = keyframes`
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  `;

  const fadeIn = keyframes`
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  `;

  const floatAnimation = keyframes`
    0% { transform: translateY(0px); }
    25% { transform: translateY(-15px); }
    50% { transform: translateY(0px); }
    75% { transform: translateY(10px); }
    100% { transform: translateY(0px); }
  `;

  const pulseAnimation = keyframes`
    0% { transform: scale(1); }
    50% { transform: scale(1.05); }
    100% { transform: scale(1); }
  `;

  const styles = {
    loginContainer: {
      width: '100%',
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: isMobile ? '1rem' : isTablet ? '1.5rem' : '2rem',
      margin: 0,
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: isMobile || isTablet ? '#e3f2fd' : 'transparent',
      ...(!isMobile && !isTablet && {
        background: 'linear-gradient(270deg, #f5f7fa, #c3cfe2, #a1c4fd, #c2e9fb)',
        backgroundSize: '400% 400%',
        animation: `${gradientAnimation} 15s ease infinite`,
      }),
    },
    formContainer: {
      width: '100%',
      maxWidth: isMobile ? '320px' : isTablet ? '450px' : '400px',
      padding: isMobile ? '1rem' : isTablet ? '1.5rem' : '1.5rem',
      boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
      borderRadius: '12px',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(5px)',
      transform: 'translateZ(0)',
    },
    logo: {
      height: isMobile ? '8vh' : isTablet ? '10vh' : '12vh',
      width: isMobile ? '8vh' : isTablet ? '10vh' : '12vh',
      margin: '5px',
      objectFit: 'contain',
      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
      animation: `${pulseAnimation} 3s ease-in-out infinite`
    },
    title: {
      fontSize: isMobile ? '1rem' : isTablet ? '1.2rem' : '1.4rem',
      textAlign: 'center',
      margin: '0.3rem 0',
      color: '#444',
      fontWeight: '600',
      textShadow: '0 1px 2px rgba(0,0,0,0.1)'
    },
    subtitle: {
      fontSize: isMobile ? '0.6rem' : isTablet ? '0.8rem' : '0.9rem',
      textAlign: 'center',
      fontStyle: 'italic',
      color: '#555',
      marginBottom: '0.5rem',
      opacity: 0.8,
      animation: `${fadeIn} 1s ease-out`
    },
    inputContainer: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid rgba(0,0,0,0.1)',
      borderRadius: '8px',
      padding: isMobile ? '0.2rem' : '0.3rem',
      marginBottom: '0.3rem',
      width: '100%',
      backgroundColor: 'rgba(255,255,255,0.8)',
      transition: 'all 0.3s ease',
      '&:focus-within': {
        borderColor: '#4a90e2',
        boxShadow: '0 0 0 2px rgba(74,144,226,0.2)'
      }
    },
    captchaContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid rgba(0,0,0,0.1)',
      borderRadius: '8px',
      padding: isMobile ? '0.2rem' : '0.3rem',
      marginBottom: '0.3rem',
      width: '100%',
      backgroundColor: 'rgba(255,255,255,0.8)',
      transition: 'all 0.3s ease',
      '&:focus-within': {
        borderColor: '#4a90e2',
        boxShadow: '0 0 0 2px rgba(74,144,226,0.2)'
      },
      transform: isMobile ? 'scale(0.85)' : isTablet ? 'scale(0.95)' : 'scale(1)',
      transformOrigin: 'center',
    },
    input: {
      flex: 1,
      border: 'none',
      outline: 'none',
      fontSize: isMobile ? '0.7rem' : isTablet ? '0.8rem' : '0.9rem',
      padding: isMobile ? '0.2rem' : '0.3rem',
      backgroundColor: 'transparent',
      '&::placeholder': {
        color: '#aaa'
      }
    },
    errorText: {
      color: '#ff4444',
      fontSize: isMobile ? '0.6rem' : '0.7rem',
      marginTop: '-0.3rem',
      marginBottom: '0.3rem',
      textAlign: 'left',
      width: '100%',
      fontWeight: '500'
    },
    button: {
      width: isMobile ? '100%' : isTablet ? '80%' : '60%',
      margin: '0.3rem 0',
      padding: isMobile ? '0.5rem' : '0.6rem',
      borderRadius: '8px',
      fontWeight: '600',
      letterSpacing: '0.5px',
      transition: 'all 0.3s ease',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 5px 15px rgba(0,0,0,0.1)'
      }
    },
    imageSection: {
      display: isMobile ? 'none' : 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)',
        zIndex: 1
      }
    },
    welcomeText: {
      fontSize: isTablet ? '1.4rem' : '1.6rem',
      color: '#333',
      marginBottom: '0.8rem',
      fontWeight: '700',
      textShadow: '0 2px 4px rgba(0,0,0,0.1)',
      animation: `${fadeIn} 0.8s ease-out`
    },
    description: {
      fontSize: isTablet ? '0.9rem' : '1rem',
      color: '#555',
      lineHeight: '1.5',
      maxWidth: isTablet ? '400px' : '450px',
      opacity: 0.9,
      animation: `${fadeIn} 1s ease-out`
    },
    backgroundAnimation: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `radial-gradient(circle at ${backgroundPosition}, rgba(161,196,253,0.3) 0%, rgba(194,233,251,0.1) 50%, rgba(255,255,255,0) 100%)`,
      transition: 'background-position 8s ease-out',
      zIndex: 0
    },
    floatingImage: {
      maxWidth: '100%',
      height: 'auto',
      maxHeight: isTablet ? '45vh' : '50vh',
      filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.1))',
      transform: imageHover ? 'perspective(1000px) rotateY(0deg) scale(1.05)' : 'perspective(1000px) rotateY(-5deg)',
      transition: 'transform 0.5s ease, filter 0.3s ease',
      animation: `${floatAnimation} 4s ease-in-out infinite`,
      cursor: 'pointer'
    }
  };

  return (
    <>
      {showSplash && (
        <SplashScreen
          duration={3000}
          onComplete={() => {
            setShowSplash(false);
          }}
        />
      )}

      <Container maxWidth={false} sx={styles.loginContainer}>
        <ToastContainer />
        {!isMobile && !isTablet && <Box sx={styles.backgroundAnimation} />}

        <Grid container sx={{
          flexGrow: 1,
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          zIndex: 1,
          height: isMobile ? 'auto' : '100vh',
          overflowY: isMobile ? 'auto' : 'visible'
        }}>
          {!isMobile && !isTablet && (
            <Grid item xs={12} md={6} sx={styles.imageSection}>
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '1rem',
                textAlign: 'center',
                position: 'relative',
                zIndex: 2
              }}>
                <img
                  alt="Document Management"
                  src={advPics}
                  style={styles.floatingImage as React.CSSProperties}
                  onMouseEnter={() => setImageHover(true)}
                  onMouseLeave={() => setImageHover(false)}
                  onClick={() => setImageHover(!imageHover)}
                />
                <Box sx={{ marginTop: '1rem' }}>
                  <h3 style={styles.welcomeText as React.CSSProperties}>Welcome to DDMSS</h3>
                  <p style={styles.description as React.CSSProperties}>
                    Streamline your document workflow with our comprehensive management system.
                    Organize, track, and access your documents with ease and efficiency.
                  </p>
                </Box>
              </Box>
            </Grid>
          )}

          <Grid item xs={12} md={isMobile || isTablet ? 12 : 6} sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: isMobile ? '0.5rem' : isTablet ? '1rem' : '1rem',
            height: isMobile || isTablet ? 'auto' : 'auto',
            overflowY: 'auto'
          }}>
            <Box sx={styles.formContainer}>
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginBottom: '1rem',
              }}>
                <img
                  alt="Logo"
                  src={logo}
                  style={styles.logo as React.CSSProperties}
                />
                <h3 style={styles.title as React.CSSProperties}>Digital Document Management System Software</h3>
                <i style={styles.subtitle as React.CSSProperties}>
                  "Efficiency Unleashed: Your Documents, Organized!"
                </i>
              </Box>

              {isAccountLocked ? (
                <LockedScreen />
              ) : (
                <>
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    handleButtonClick();
                  }}
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}>
                    <Box sx={{ marginBottom: '1rem', width: '100%' }}>
                      <Box sx={styles.inputContainer}>
                        <FontAwesomeIcon
                          icon={faUser}
                          style={{ color: '#4a90e2', margin: '0 5px' }}
                        />
                        <input
                          type="text"
                          name="useR_ID"
                          autoComplete="off"
                          id="useR_ID"
                          value={formik.values.useR_ID}
                          placeholder="Username"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={styles.input}
                        />
                      </Box>
                      {formik.touched.useR_ID && formik.errors.useR_ID && (
                        <div style={styles.errorText as React.CSSProperties}>{formik.errors.useR_ID}</div>
                      )}

                      <Box sx={styles.inputContainer}>
                        <FontAwesomeIcon
                          icon={faLock}
                          style={{ color: '#4a90e2', margin: '0 5px' }}
                        />
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          autoComplete="off"
                          id="password"
                          value={formik.values.password}
                          placeholder="Password"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={styles.input}
                        />
                        <FontAwesomeIcon
                          icon={showPassword ? faEyeSlash : faEye}
                          style={{ color: '#4a90e2', margin: '0 5px', cursor: 'pointer' }}
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      </Box>
                      {formik.touched.password && formik.errors.password && (
                        <div style={styles.errorText as React.CSSProperties}>{formik.errors.password}</div>
                      )}

                      {/* CAPTCHA Component */}
                      <Box sx={styles.captchaContainer}>
                        <ReCAPTCHA
                          ref={recaptchaRef}
                          sitekey={recaptchaSiteKey}
                          onChange={handleCaptchaChange}
                          onExpired={handleCaptchaExpired}
                        />
                      </Box>
                    </Box>

                    <Box sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      width: '100%',
                    }}>
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={loading}
                        sx={styles.button}
                        onClick={handleButtonClick}
                        type="submit"
                      >
                        {loading ? (
                          <CircularProgress size={isMobile ? 20 : 24} style={{ color: "white" }} />
                        ) : (
                          "Sign In"
                        )}
                      </Button>
                    </Box>
                  </form>
                  <AttemptsMessage />
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default LoginPage;